import { POKER_CONFIGURATION_PAGES } from "./constants/poker/pokerConfigurationData";
import {
  AGENT_AUDIT_LOG_ROUTE_PERMISSIONS,
  MAINTENANCE_MODE_ROUTE_PERMISSIONS,
  WITHDRAWAL_REVIEW_ROUTE_PERMISSIONS,
  DUPLICATE_IDENTITY_REVIEW_ROUTE_PERMISSIONS,
} from "./constants/permissionsConstants";
import { NAVIGATION_ROUTES } from "./NavigationUtils";
import { TRIVELTA_PRODUCTS } from "./products";

// export const PROFILE_IMAGE_BASE_URL = "https://api.trivet.app/admin_panel/v2/admin";
// export const ADMIN_PANEL_BACKEND_BASE_URL = "https://d15squdqw4bryq.cloudfront.net";
// export const ADMIN_PANEL_CLOUDFRONT_URL = "https://d18hitibem9he3.cloudfront.net";
// export const ADMIN_DASHBOARD_BACKEND_BASE_URL = "https://y1s0b9goh2.execute-api.us-east-2.amazonaws.com/prod";
// export const AFFILIATE_PANEL_BACKEND_INSTANCE = "https://559xyery3g.execute-api.us-east-2.amazonaws.com/dev/admin-management-v3";
// export const ADMIN_PANEL_WEBSOCKET_BASE_URL = "wss://qo2hqhji2a.execute-api.us-east-2.amazonaws.com/dev";

export const BRAND_ICONS_URLS = {
  companylogo: "/common_assets/icons/company_logo.png", //IMAGES.primaryLogo
  appNameLogo: "/common_assets/icons/app_name_logo.png", //IMAGES.brandName
  primaryCurrencySymbol: "/common_assets/icons/primary_currency.png", //IMAGES.CoinIcon
  secondaryCurrencySymbol: "/common_assets/icons/secondary_currency.png", //IMAGES.CashIcon
  // iOSAppIcon:"/common_assets/icons/ios_icon.png",
  // androidAppIcon:"/common_assets/icons/android_icon.png",
  topLeftAppIcon: "/common_assets/icons/topleft_icon.png", //IMAGES.blackLogo
  websiteFavicon: "/common_assets/icons/favicon.ico",
};

// Stable tab identities for selectedSiderTab / whichDropdownOpen comparisons
// and Layout names — NOT display copy. The sidebar renders display labels via
// `labelKey` in src/utils/sider/siderMenuModel.jsx (using sidebarLabels.js), so
// these values must never be localized: a locale-dependent value here would
// break every identity comparison after a locale switch.
export const SIDER_TABS = {
  REPORTING_SUMMARY: "Reporting Summary",
  TOP_USERS: "Top Users",
  EVENTS_LIST: "Events List",
  USERS: "Users",
  USERS_NEW: "Users - New",
  PLAYERS: "Players - DEMO",
  SPORTSBOOK: "Sportsbook",
  KPIS: "KPIs",
  AFFILIATE: "Affiliates",
  ADMIN: "Admin",
  EVENTS: "Events",
  STAFF_MANAGEMENT: "Staff Management",
  STAFF_MANAGEMENT_NEW: "Staff Management",
  PAYMENTS: "Payments",
  DELAYED_PAYMENT: "Delayed Payment",
  PRIZE_REDEMPTION_MANUAL_REVIEW: "Prize Redemption Manual Review",
  PROMOTIONS: "Promotions",
  CONFIGURATIONS: "Configurations",
  DASHBOARD: "Dashboard",
  REPORTS: "Reports",
  MARKETING: "Marketing",
  CASINO: "Casino",
  PREDICTIONS: "Predictions",
  GAME_PASS: "Game Pass",
  POKER: "Poker",
  COMPLIANCE: "Compliance",
  MOBILE_BUILD_DOWNLOADS: "Deployed Builds",
};

export const USER_HEADER_TABS = {
  OVERVIEW: "overview",
  TRANSACTIONS: "transactions",
  PAYMENTS: "payments",
  PROMOTIONS: "promotions",
  BETS: "bets",
  CASINO_BETS: "casino-bets",
  POKER_BETS: "poker-bets",
  PIKKEM: "pikkem",
  GAME_PASS: "game-pass",
  ALT_ODS: "alt-ods",
};

export const TIME_FRAMES = {
  MONTH: "month",
  DAY: "day",
};

export const DATE_RANGE = {
  LAST_7_DAYS: "Last 7 days",
  LAST_21_DAYS: "Last 21 days",
  LAST_30_DAYS: "Last 30 days",
  LAST_45_DAYS: "Last 45 days",
  // Month-to-date: start of current month → end of today.
  // NB: distinct from "This Month" preset which uses startOf-month →
  // endOf-month (so the upper bound includes future days that haven't
  // happened yet — wrong for analytics).
  CURRENT_MONTH: "Current Month",
};

export const BET_STATUS = {
  WON: "won",
  LOST: "lost",
  PUSHED: "pushed",
  UNSETTLED: "unsettled",
  CANCELLED: "cancelled",
};

export const ADMIN_TYPES = {
  NEW_SUPER_ADMIN: "superadmin",
  SUPER_ADMIN: "super-admin-v2",
  CUSTOMER_SUPPORT: "customer-support",
  COMPLIANCE_AGENT: "compliance-agent",
};

export const KPI_PAGE_PERMISSIONS = {
  OVERVIEW: "kpis.overview",
  FINANCIALS: "kpis.financials",
  ACQUISITION: "kpis.acquisition",
  SPORTSBOOK: "kpis.sportsbook",
  CASINO: "kpis.casino",
};

export const SHOW_ALL_KPI_SECTIONS = false;

// PAM team members allowed to see sidebar entries gated by a `user_whitelist`.
// IMPORTANT: usernames and emails must be kept in parallel — when adding a
// team member, add to BOTH lists. usernames are BE email.split("@")[0].
export const PAM_TEAM_WHITELIST = {
  usernames: [
    "zak",
    "elizabeth.turano",
    "benjamin.orozco",
    "duncan.korkosz",
    "rob.klock",
    "pratik.jadhav",
    "victor.campos",
    "superadmin",
    "michael.marceau",
    "yoshi.tryba",
  ],
  emails: [
    "zak@trivelta.com",
    "elizabeth.turano@trivelta.com",
    "benjamin.orozco@trivelta.com",
    "duncan.korkosz@trivelta.com",
    "rob.klock@trivelta.com",
    "pratik.jadhav@trivelta.com",
    "victor.campos@trivelta.com",
    "admin@trivelta.com",
    "michael.marceau@trivelta.com",
    "yoshi.tryba@trivelta.com",
  ],
};

export const AGENT_ACTIONS = {
  EDIT_USER_WALLET: "edit_user_wallet",
  SUSPEND_USER: "suspend_user",
  UNSUSPEND_USER: "unsuspend_user",
  ADD_LIMITS: "add_limits",
  SETTLE_BET: "settle_bet",
  SUSPEND_DISABLE_PAM_USER: "suspend_disable_pam_user",
  EDIT_SPORTSBOOK_FM: "edit_sportsbook_fm",
  EDIT_CASINO_FM: "edit_casino_fm",
  EDIT_TRANSACTION_ROUTING: "edit_transaction_routing",
  REVIEW_WITHDRAWAL: "review_withdrawal",
  REFUND_WITHDRAWAL: "refund_withdrawal",
  CREATE_PAM_USER: "create_pam_user",
  EDIT_PAM_USER: "edit_pam_user",
  CREATE_EDIT_PAM_ROLE: "create_edit_pam_role",
  USERS_EXPORT: "users.export",
  PAYMENTS_REPORTS_EXPORT: "payments.reports.export",
};

export const FEATURE_GUARD_ALLOWED_ENVIRONMENTS = ["test03"];

export const PERMISSIONS = {
  USERS_WALLET_UPDATE: "users.wallet.update",
};

export const PERSONAL_LIMITS = {
  TIME_LIMITS: "time limits",
  CURRENCY_LIMITS: "currency limits",
  WAGGER_LIMITS: "wagger limits",
  LOSS_LIMITS: "loss limits",
  CASINO_LIMITS: "casino limits",
};

export const KPI_CARD_BACKGROUND = {
  LIGHT: "var(--COLOR-LIGHT_TEXT_COLOR)",
  DARK: "var(--COLOR-SPIN_GRAD_COLOR_1 )",
  TRASNPARENT: "transparent",
  DEFAULT_BORDER_GRADIENT_0: "var(--COLOR-SPIN_GRAD_COLOR_1 )",
  DEFAULT_BORDER_1PX: "1px solid var(--COLOR-DEFAULT_BORDER_GRADIENT_0)",
  GREY_750: "var(--grey-750)"
};

export const FREE_BET_TYPES = {
  WAGERED: "wagered",
  PAIDOUT: "paidout",
};

// Sidebar entries carry `labelKey` (an AppStrings key) instead of a label
// string: module-level `label:` captures freeze the bundled English before
// loadAppStringsForLanguage() runs, so display copy must be resolved at
// render time (see src/utils/sidebarLabels.js). The `labelKey` doubles as
// the selection identity used by setActiveSidebarTab sub-tab highlighting,
// so it must stay locale-independent.
export const SPORTSBOOK_OPTIONS = [
  {
    id: "sportsbook-reporting",
    labelKey: "PAM_REPORTING",
    children: [
      {
        id: "sportsbook-reporting-summary",
        labelKey: "SPORTSBOOK_REPORTING_SUMMARY",
        navigate: NAVIGATION_ROUTES?.REPORTING_SUMMARY,
        access_role: ["sportsbook.reporting","sportsbook.reporting.reporting_summary"],
      },
      {
        id: "sportsbook-reporting-top-users",
        labelKey: "TOP_USERS",
        navigate: NAVIGATION_ROUTES?.SPORTSBOOK_TOP_USERS,
        access_role: ["sportsbook.reporting.top_users"],
      },
    ],
    allowEmptyMenu: false,
  },
  {
    id: "sportsbook-fieldbook",
    labelKey: "EVENTS_LIST",
    navigate: NAVIGATION_ROUTES?.FIELDBOOK_EVENTS_LIST,
    access_role: ["sportsbook.fieldbook","sportsbook.fieldbook.events_list"],
  },
  {
    id: "sportsbook-monitoring",
    labelKey: "PAM_MONITORING",
    children: [
      {
        id: "sportsbook-monitoring-latest-bets-list",
        labelKey: "LATEST_BETS_LIST",
        navigate: NAVIGATION_ROUTES?.MONITORING_LATEST_BETS_LIST,
        access_role: ["sportsbook.monitoring.latest_bets_list"],
      },
      {
        id: "sportsbook-monitoring-sgp-risk",
        labelKey: "SPORTSBOOK_SGP_RISK",
        navigate: NAVIGATION_ROUTES?.SGP_RISK,
        access_role: ["sportsbook.monitoring.sgp_risk"],
      },
    ],
    allowEmptyMenu: false,
  },
  {
    id: "sportsbook-configuration",
    labelKey: "CONFIGURATION",
    children: [
      {
        id: "sportsbook-configuration-bet-limits",
        labelKey: "BET_LIMITS",
        navigate: NAVIGATION_ROUTES?.CONFIGURATION_BET_LIMITS,
        access_role: ["sportsbook.configuration.bet_limits"],
      },
      {
        id: "sportsbook-configuration-sgp-limits",
        labelKey: "SPORTSBOOK_SGP_LIMITS",
        navigate: NAVIGATION_ROUTES?.SPORTSBOOK_LIMITS,
        access_role: ["sportsbook.configuration.sgp_limits"],
      },
      {
        id: "sportsbook-configuration-account-config",
        labelKey: "ACCOUNT_CONFIG",
        navigate: NAVIGATION_ROUTES?.CONFIGURATION_ACCOUNT_CONFIG,
        access_role: ["sportsbook.configuration.account_config"],
        development_mode: true,
      },
      {
        id: "sportsbook-configuration-early-payout",
        labelKey: "EARLY_PAYOUT",
        navigate: NAVIGATION_ROUTES?.CONFIGURATION_EARLY_PAYOUT,
        access_role: ["sportsbook.configuration.early_payout"],
        development_mode: false,
      },
      {
        id: "sportsbook-configuration-sportsbook-fm",
        labelKey: "SPORTSBOOK_FM",
        navigate: NAVIGATION_ROUTES?.SPORTSBOOK_FM,
        innerFeatureFlags: ["sportsbook_v2"],
        access_role: ["sportsbook.configuration.sportsbook_fm", "configuration.sportsbook_fm"],
      },
    ],
    allowEmptyMenu: false,
  },
];

/** Casino sidebar: nested Reports → Finance / Providers / Games (see Figma). */
export const CASINO_OPTIONS = [
  {
    id: "casino-reports",
    labelKey: "REPORTS",
    children: [
      {
        id: "casino-reports-finance",
        labelKey: "FINANCE",
        navigate: NAVIGATION_ROUTES?.CASINO_FINANCE_REPORTS,
        access_role: ["casino.reports.finance"],
      },
      {
        id: "casino-reports-providers",
        labelKey: "PROVIDERS",
        navigate: NAVIGATION_ROUTES?.CASINO_REPORTS_PROVIDERS,
        access_role: ["casino.reports.providers"],
      },
      {
        id: "casino-reports-games",
        labelKey: "GAMES",
        navigate: NAVIGATION_ROUTES?.CASINO_REPORTS_GAMES,
        access_role: ["casino.reports.games"]
      },
      {
        id: "casino-reports-top-users",
        labelKey: "TOP_USERS",
        navigate: NAVIGATION_ROUTES?.CASINO_TOP_USERS,
        access_role: ["casino.reports.top_users"],
      },
    ],
  },
  {
    id: "casino-configuration",
    labelKey: "CONFIGURATION",
    children: [
      {
        id: "casino-configuration-games",
        labelKey: "CASINO_CONFIGURATION_GAMES",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_GAMES,
        access_role: ["casino.configuration.games"],
      },
      {
        id: "casino-configuration-providers",
        labelKey: "CASINO_CONFIGURATION_PROVIDERS",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_PROVIDERS,
        access_role: ["casino.configuration.providers"],
      },
      {
        id: "casino-configuration-catalogs",
        labelKey: "COLLECTIONS",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_CATALOGS,
        access_role: ["casino.configuration.collections"],
      },
      {
        id: "casino-configuration-views",
        labelKey: "CASINO_CONFIGURATION_VIEWS",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_VIEWS,
        access_role: ["casino.configuration.views"],
      },
      {
        // CASENG-995: per-client platform-config gate. Hidden unless
        // `casino_features.casino_configuration_pages` is on for the client.
        id: "casino-configuration-pages",
        labelKey: "CASINO_CONFIGURATION_PAGES",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_PAGES,
        access_role: ["casino.configuration.pages"],
        featureFlag: "casinoConfigurationPages",
      },
      {
        id: "casino-configuration-tags",
        labelKey: "CASINO_CONFIGURATION_TAGS",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_TAGS,
        access_role: ["casino.configuration.tags"],
      },
      {
        id: "casino-configuration-preview",
        labelKey: "CASINO_CONFIGURATION_PREVIEW",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_PREVIEW,
        access_role: ["casino.configuration.preview"],
      },
      {
        // CASENG-976: permission-gated (same contract as Games). Jackpot UI
        // remains env-gated inside the Features page until GA.
        id: "casino-configuration-features",
        labelKey: "CASINO_CONFIGURATION_FEATURES",
        navigate: NAVIGATION_ROUTES?.CASINO_CONFIGURATION_FEATURES,
        access_role: ["casino.configuration.features"],
      },
    ],
  },
];

// POKENG-188: Reports is listed above Configuration to match the other
// product tabs (see CASINO_OPTIONS). Entire section is WIP —
// `development_mode: true` keeps it off STG/prod until Poker is ready
// for GA (same pattern as Predictions).
export const POKER_OPTIONS = [
  {
    id: "poker-reports-group",
    labelKey: "REPORTS",
    development_mode: true,
    children: [
      {
        id: "poker-reports-top-users",
        labelKey: "TOP_USERS",
        navigate: NAVIGATION_ROUTES?.POKER_TOP_USERS,
        access_role: ["poker.reporting.top_users"],
        development_mode: true,
        user_whitelist: PAM_TEAM_WHITELIST,
      },
    ],
  },
  {
    id: "poker-configuration",
    labelKey: "CONFIGURATION",
    development_mode: true,
    children: [
      {
        id: "poker-configuration-cash-game-limits",
        labelKey: "POKER_CASH_GAME_LIMITS",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_CASH_GAME_LIMITS,
        access_role: [POKER_CONFIGURATION_PAGES.cashGameLimits.permission],
        development_mode: true,
      },
      {
        id: "poker-configuration-stakes",
        labelKey: "POKER_CASH_GAME_STAKES",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_STAKES,
        access_role: [POKER_CONFIGURATION_PAGES.stakes.permission],
        development_mode: true,
      },
      {
        id: "poker-configuration-private-games",
        labelKey: "POKER_PRIVATE_GAMES",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_PRIVATE_GAMES,
        access_role: [POKER_CONFIGURATION_PAGES.privateGames.permission],
        development_mode: true,
      },
      {
        id: "poker-configuration-tournaments",
        labelKey: "POKER_TOURNAMENTS",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_TOURNAMENTS,
        access_role: [POKER_CONFIGURATION_PAGES.tournaments.permission],
        development_mode: true,
      },
      {
        id: "poker-configuration-timebank",
        labelKey: "POKER_TIMEBANK",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_TIMEBANK,
        access_role: [POKER_CONFIGURATION_PAGES.timebank.permission],
        development_mode: true,
      },
      {
        id: "poker-configuration-features",
        labelKey: "POKER_FEATURES",
        navigate: NAVIGATION_ROUTES?.POKER_CONFIGURATION_FEATURES,
        access_role: [POKER_CONFIGURATION_PAGES.features.permission],
        development_mode: true,
      },
    ],
  },
];

// AppStrings KEYS (not labels) for the Game Pass → Configuration sidebar
// dropdown children. Single source of truth for both the sidebar entries
// below and the `setActiveSidebarTab(SIDER_TABS.GAME_PASS, ...)` callsites
// in the Game Pass pages: matching by key keeps the sub-tab highlight
// working in every locale, where matching by (translated) label cannot.
export const GAME_PASS_DROPDOWN_LABELS = {
  SEASONS: "GAME_PASS_SEASONS",
  DAILY: "GAME_PASS_DAILY",
  MONTHLY: "GAME_PASS_MONTHLY",
  STYLE: "GAME_PASS_STYLE",
};

// POKENG-188 (same convention as Poker): Reports is listed above
// Configuration to match the other product tabs (see CASINO_OPTIONS).
export const GAME_PASS_OPTIONS = [
  {
    id: "game-pass-reports",
    labelKey: "REPORTS",
    access_role: ["game_pass.reporting"],
    // WIP — no report children yet; keep dev-only until the section ships.
    development_mode: true,
    children: [],
  },
  {
    id: "game-pass-configuration",
    labelKey: "CONFIGURATION",
    children: [
      {
        id: "game-pass-configuration-seasons",
        labelKey: GAME_PASS_DROPDOWN_LABELS.SEASONS,
        navigate: NAVIGATION_ROUTES?.GAME_PASS_CONFIGURATION_SEASONS,
        access_role: ["game_pass.configuration.seasons"],
      },
      {
        id: "game-pass-configuration-daily",
        labelKey: GAME_PASS_DROPDOWN_LABELS.DAILY,
        access_role: ["game_pass.configuration.daily"],
        development_mode: true,
      },
      {
        id: "game-pass-configuration-monthly",
        labelKey: GAME_PASS_DROPDOWN_LABELS.MONTHLY,
        navigate: NAVIGATION_ROUTES?.GAME_PASS_CONFIGURATION_MONTHLY,
        access_role: ["game_pass.configuration.monthly"],
      },
      {
        id: "game-pass-configuration-style",
        labelKey: GAME_PASS_DROPDOWN_LABELS.STYLE,
        navigate: NAVIGATION_ROUTES?.GAME_PASS_CONFIGURATION_STYLE,
        access_role: ["game_pass.configuration.style"],
        development_mode: true,
      },
    ],
  },
];

export const PROMOTIONS_OPTIONS = [
  {
    id: "default",
    labelKey: "BONUS_CONTROLS",
    navigate: NAVIGATION_ROUTES?.PROMOTIONS,
    access_role: ["promotions.bonus_controls"],
  },
  {
    // GA — Affiliates UI on the canonical `/marketing-affiliates*` paths.
    // Legacy `/marketing-affiliates-v2*` URLs redirect in App.js.
    id: "affiliates",
    labelKey: "AFFILIATES",
    navigate: NAVIGATION_ROUTES?.MARKETING_AFFILIATES,
    access_role: ["promotions.affiliates"],
  },
  {
    id: "utm-reports",
    labelKey: "UTM_REPORTS",
    navigate: NAVIGATION_ROUTES?.UTM_REPORTS,
    access_role: ["promotions.utm_reports"],
  },
  // Campaigns is the only Dynamic Bonuses entry here: Templates and Segments
  // are reached from buttons in the Campaigns page toolbar (BONENG-967).
  {
    id: "dynamic-bonuses-campaigns",
    labelKey: "PAM_CAMPAIGNS",
    navigate: NAVIGATION_ROUTES?.DYNAMIC_BONUS_CAMPAIGNS,
    featureFlag: "dynamicBonuses",
    access_role: ["promotions.campaigns"],
  },
];

export const PAYMENTS_OPTIONS = [
  {
    id: "payments-reports",
    labelKey: "REPORTS",
    children: [
      {
        // Whitelisted Payment Reporting dashboard; only listed admins see it.
        id: "payments-reports-overview",
        labelKey: "OVERVIEW",
        navigate: NAVIGATION_ROUTES?.PAYMENT_REPORTING,
        access_role: ["payments.reports.overview"],
        user_whitelist: PAM_TEAM_WHITELIST,
      },
      {
        id: "transactions-reports",
        labelKey: "PAM_REPORT_GENERATOR",
        navigate: NAVIGATION_ROUTES?.TRANSACTIONS_REPORTS,
        access_role: ["payments.reports.report_generator"],
      },
    ],
  },
  {
    id: "payments-configuration",
    labelKey: "CONFIGURATION",
    children: [
      {
        id: "transactions-routing",
        labelKey: "PAYMENTS_ROUTING",
        navigate: NAVIGATION_ROUTES?.TRANSACTIONS_ROUTING,
        featureFlag: "transactions_routing",
        access_role: ["payments.configuration.routing"],
      },
      {
        id: "finix-delayed-payment",
        labelKey: "DELAYED_PAYMENT",
        navigate: NAVIGATION_ROUTES?.DELAYED_PAYMENT,
        access_role: ["payments.configuration.delayed_payment"],
      },
      {
        id: "payments-configuration-limits",
        labelKey: "LIMITS",
        navigate: NAVIGATION_ROUTES?.PAYMENTS_CONFIGURATION_LIMITS,
        access_role: ["payments.configuration.limits"],
        development_mode: true,
        user_whitelist: PAM_TEAM_WHITELIST,
      },
    ],
  },
];

/**
 * Predictions sidebar (below Casino): Reports → Configuration.
 * Entire section is WIP — `development_mode: true` keeps it off STG/prod
 * until pages and permissions ship (same pattern as Game Pass Reports).
 */
export const PREDICTIONS_OPTIONS = [
  {
    id: "predictions-reports",
    labelKey: "REPORTS",
    navigate: NAVIGATION_ROUTES?.PREDICTIONS_REPORTS,
    access_role: ["predictions.reports"],
    development_mode: true,
    user_whitelist: PAM_TEAM_WHITELIST,
  },
  {
    id: "predictions-configuration",
    labelKey: "CONFIGURATION",
    navigate: NAVIGATION_ROUTES?.PREDICTIONS_CONFIGURATION,
    access_role: ["predictions.configuration"],
    development_mode: true,
    user_whitelist: PAM_TEAM_WHITELIST,
  },
];

/**
 * Configurations sidebar (below Compliance, above Staff): Profile.
 * Visibility uses `access_role: ["configurations.profile"]` (no
 * `features.quick_access`). The Sider tab is also gated on TCM product
 * `core_app`. The route additionally requires `featureFlag: "featureQuickAccess"`.
 */
export const CONFIGURATIONS_OPTIONS = [
  {
    id: "configurations-profile",
    labelKey: "PROFILE_CONFIGURATION_PAGE_TITLE",
    navigate: NAVIGATION_ROUTES?.CONFIGURATIONS_PROFILE,
    access_role: ["configurations.profile"],
  },
  {
    id: "configurations-state-configuration",
    labelKey: "PAM_STATE_CONFIGURATION_PAGE_TITLE",
    navigate: NAVIGATION_ROUTES?.CONFIGURATIONS_STATE_CONFIGURATION,
    access_role: ["configurations.state_configuration"],
    development_mode: true,
    user_whitelist: PAM_TEAM_WHITELIST,
    required_product: TRIVELTA_PRODUCTS.PREDICTIONS,
    required_product_catalog_only: true,
  },
  {
    id: "configurations-kyc",
    labelKey: "KYC_CONFIGURATION",
    navigate: NAVIGATION_ROUTES?.CONFIGURATIONS_KYC,
    access_role: ["compliance"],
    // Unlike State Configuration above, this entry is NOT `development_mode` /
    // whitelist gated — it ships to every environment. Keep it that way, and
    // see the Configurations tab gate in `useSidebarSections`, which decides
    // whether to render in prod from the non-dev options (Profile and this one).
    // Both flags: SURT is the provider, surtCheckpoints the checkpoints
    // feature on top of it. Either off → no menu entry; the route itself stays
    // reachable and renders a disabled notice (a redirect would loop).
    featureFlag: ["surt", "surtCheckpoints"],
  },
  {
    // CASENG-1048: manual trigger + run history for scheduled tasks.
    // Purposes are casino-only today, so visibility keeps the casino
    // permission and hides for non-casino tenants via the catalog-only
    // product gate (`isProductActive` without a fallback would fail open
    // in prod — see FeatureFlagService.isProductActive).
    id: "configurations-scheduled-tasks",
    labelKey: "CASINO_SCHEDULED_TASKS",
    navigate: NAVIGATION_ROUTES?.CONFIGURATIONS_SCHEDULED_TASKS,
    access_role: ["casino.scheduled_tasks.read"],
    required_product: TRIVELTA_PRODUCTS.CASINO,
    required_product_catalog_only: true,
  },
];

export const COMPLIANCE_OPTIONS = [
  {
    id: "transactions-wallet",
    labelKey: "WALLET",
    navigate: NAVIGATION_ROUTES?.TRANSACTIONS_WALLET,
    access_role: ["compliance.wallet"],
  },
  {
    id: "withdrawal-review",
    labelKey: "WITHDRAWAL_REVIEW_TITLE",
    navigate: NAVIGATION_ROUTES?.WITHDRAWAL_REVIEW,
    access_role: [...WITHDRAWAL_REVIEW_ROUTE_PERMISSIONS],
  },
  {
    id: "fraud-detection",
    labelKey: "FRAUD_DETECTION",
    navigate: NAVIGATION_ROUTES?.FRAUD_DETECTION,
    access_role: ["compliance.fraud_detection"],
  },
  {
    id: "duplicate-identity-review",
    labelKey: "KYC_DUPLICATE_IDENTITY_REVIEW_TITLE",
    navigate: NAVIGATION_ROUTES?.DUPLICATE_IDENTITY_REVIEW,
    access_role: [...DUPLICATE_IDENTITY_REVIEW_ROUTE_PERMISSIONS],
    featureFlag: "duplicateIdentityReview",
  },
  {
    id: "compliance-maintenance-mode",
    labelKey: "MAINTENANCE_MODE",
    navigate: NAVIGATION_ROUTES?.COMPLIANCE_MAINTENANCE_MODE,
    access_role: [...MAINTENANCE_MODE_ROUTE_PERMISSIONS],
  },
];

export const STAFF_MANAGEMENT_NEW_OPTIONS = [
  {
    id: "staff",
    labelKey: "STAFF",
    navigate: NAVIGATION_ROUTES?.STAFF_MANAGEMENT_NEW,
    access_role: ["staff_management.staff"],
    development_mode: false,
  },
  {
    id: "agent-audit-log",
    labelKey: "AGENT_AUDIT_LOG",
    navigate: NAVIGATION_ROUTES?.AGENT_AUDIT_LOG,
    access_role: [...AGENT_AUDIT_LOG_ROUTE_PERMISSIONS],
    development_mode: false,
  },
];

export const ADMIN_OPTIONS = [
  {
    id: "create-account",
    labelKey: "PAM_CREATE_ACCOUNT",
    navigate: NAVIGATION_ROUTES?.CREATE_ACCOUNT,
    access_role: "admin.create_account",
  },
  // {
  //   id: "customer-support-controls",
  //   label: "Customer Support Controls",
  //   navigate: NAVIGATION_ROUTES?.CUSTOMER_SUPPORT_CONTROLS,
  // },
];

// Public assets base: sport/league logos bucket
export const SPORT_LOGO_BASE_URL =
  "https://rebet-backend.s3.us-east-2.amazonaws.com/league_logos";

export const CASINO_PROVIDERS_INNER_FLAGS = [
  "aggregator",
  "threeoaks",
  "spribe",
  "evolution",
  "booming",
  "saGaming",
  "3oaks",
  "jacktop",
  "pragmatic",
  "goldenrace",
  "betcore",
  "royal",
  "bgaming",
  "iconic21",
  "kerma",
];

export const SPORTSBOOK_PROVIDERS_INNER_FLAGS = [
  "onefeed",
  "sportsradar",
  "dst",
  "oddin",
];

export const AGENT_AUDIT_LOG_ACTION_TYPES = [
  "WALLET_CREDITED",
  "WALLET_DEBITED",
  "AGENT_SIGNED_IN",
  "AGENT_SIGNED_OUT",
  "WITHDRAWAL_REVIEW_STARTED",
  "WITHDRAWAL_APPROVED",
  "WITHDRAWAL_DECLINED",
  "FREE_PICK_ADDED",
  "FREE_PICK_REMOVED",
  "PROFIT_BOOST_ADDED",
  "PROFIT_BOOST_REMOVED",
  "FREE_SPIN_ADDED",
  "FREE_SPIN_REMOVED",
  "BET_SETTLED",
  "BET_VOIDED",
  "USER_SUSPENDED",
  "USER_UNSUSPENDED",
  "USER_ACCOUNT_DELETED",
  "LEG_SETTLED",
  "BET_SETTLED",
  "BET_CANCELLED",
  "BET_ROLLED_BACK",
];

